import React from 'react';

const NotFound = () => (
  <p>Whoops. Not found.</p>
);

export default NotFound;
